/* eslint-disable */
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import PlatformLayout from '../../components/PlatformLayout'
import AddProviderAndClient from './AddProviderAndClient'
import { Paper } from '@mui/material'
import '../../globalStyle.scss'
import ExceptionList from './ExceptionList'
import VipList from './VipList'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderRole } from '../../utils/provider'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export default function SettingDetails() {
  const { t } = useTranslation()
  const { customerId } = useContext(OrgAppContext)
  let query = useQuery()
  let type = query.get('type')

  const { id } = useParams<{ id: string }>()
  const ruleId = id || ''

  if (type === 'AccessSelf')
    return (
      <Paper
        square
        elevation={0}
        className='paperStyle'
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div className='ruleSettingDetailsTitle'>
          {t('alertType.AccessSelf', { providerRole: getProviderRole(customerId) })}
        </div>
        <Paper
          square
          elevation={0}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 212px)',
            overflow: 'auto',
          }}
        >
          <AddProviderAndClient />
          <ExceptionList ruleId={ruleId} />
        </Paper>
      </Paper>
    )

  if (type === 'AccessInternal')
    return (
      <Paper
        square
        elevation={0}
        className='paperStyle'
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div className='ruleSettingDetailsTitle'>
          {t('alertType.AccessInternal', { providerRole: getProviderRole(customerId) })}
        </div>
        <Paper
          square
          elevation={0}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 212px)',
            overflow: 'auto',
          }}
        >
          <AddProviderAndClient />
          <ExceptionList ruleId={ruleId} />
        </Paper>
      </Paper>
    )

  if (type === 'AccessVIP')
    return (
      <Paper
        square
        elevation={0}
        className='paperStyle'
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div className='ruleSettingDetailsTitle'>
          {t('alertType.AccessVIP', { providerRole: getProviderRole(customerId) })}
        </div>
        <Paper
          square
          elevation={0}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 212px)',
            overflow: 'auto',
          }}
        >
          <VipList ruleId={ruleId} />
          <ExceptionList ruleId={ruleId} />
        </Paper>
      </Paper>
    )

  if (type === 'AccessRelatives')
    return (
      <Paper
        square
        elevation={0}
        className='paperStyle'
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div className='ruleSettingDetailsTitle'>
          {t('alertType.AccessRelatives', { providerRole: getProviderRole(customerId) })}
        </div>
        <Paper
          square
          elevation={0}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 212px)',
            overflow: 'auto',
          }}
        >
          <ExceptionList ruleId={ruleId} />
        </Paper>
      </Paper>
    )

  if (type === 'AccessFamily')
    return (
      <Paper
        square
        elevation={0}
        className='paperStyle'
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div className='ruleSettingDetailsTitle'>
          {t('alertType.AccessFamily', { providerRole: getProviderRole(customerId) })}
        </div>
        <Paper
          square
          elevation={0}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 212px)',
            overflow: 'auto',
          }}
        >
          <ExceptionList ruleId={ruleId} />
        </Paper>
      </Paper>
    )

  if (type === 'AccessNeighbors')
    return (
      <Paper
        square
        elevation={0}
        className='paperStyle'
        style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div className='ruleSettingDetailsTitle'>
          {t('alertType.AccessNeighbors', { providerRole: getProviderRole(customerId) })}
        </div>
        <Paper
          square
          elevation={0}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 212px)',
            overflow: 'auto',
          }}
        >
          <ExceptionList ruleId={ruleId} />
        </Paper>
      </Paper>
    )

  return <div>error</div>
}
